import { render, staticRenderFns } from "./Nominee.html?vue&type=template&id=cbaf43b6&scoped=true&external"
import script from "./Nominee.vue?vue&type=script&lang=js"
export * from "./Nominee.vue?vue&type=script&lang=js"
import style0 from "./Nominee.scss?vue&type=style&index=0&id=cbaf43b6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbaf43b6",
  null
  
)

export default component.exports